import { Box } from '@mui/material';
import React, { useState } from 'react';

export const getCompanyImageProps = (tags, tagId, options = {}) => {
  const fallback = options.fallback || 'https://assets.languify.in/images/codeTag.png';
  const style = options.style || {};
  const width = options.width || 56;
  const alt = options.alt || 'tag';

  // Determine the correct image URL based on tagId
  let imageUrl = fallback;
  if (tagId) {
    const matchedTag = tags?.find(tag => tag._id === tagId);
    if (matchedTag?.code) {
      imageUrl = `https://assets.languify.in/images/${matchedTag.code}.png`;
    }
  }

  const SafeImage = () => {
    const [error, setError] = useState(false);

    return (
      <Box style={style}>
        <img
          src={error ? fallback : imageUrl}
          alt={alt}
          width={width}
          onError={() => setError(true)}
          style={{ borderRadius: '12px' }}
        />
      </Box>
    );
  };

  return SafeImage;
};
